const setFeaturesEnabledState = (features, featureName = "") => {
  const tmpFeatures = Object.entries(features).reduce((acc, [name, data]) => {
    const enabled = featureName ? data.enabled : true;
    acc[name] = { ...data, enabled };
    return acc;
  }, {});

  const tmpFeature = tmpFeatures[featureName];
  return {
    ...tmpFeatures,
    ...(tmpFeature
      ? {
          [featureName]: {
            ...tmpFeature,
            enabled: !tmpFeature.enabled,
          },
        }
      : {}),
  };
};

export default {
  namespaced: true,
  state: {
    features: {},
    featuresFilter: "",
    defaultFeatures: {},
    showCookieBanner: false,
    cookieName: "featureConsents",
  },
  getters: {
    features: state =>
      Object.fromEntries(
        Object.entries(state.features).filter(([name]) => name.match(state.featuresFilter))
      ),
    feature: state => featureName => state.features[featureName],
    showCookieBanner: state => state.showCookieBanner,
  },
  actions: {
    setFeatures: (context, { data, options = {} }) => {
      const features = data.reduce((acc, feature) => {
        acc[feature.name] = feature;
        return acc;
      }, {});

      context.commit("setFeatures", features);
      if (options.setDefault) {
        context.commit("setDefaultFeatures", features);
      }
    },
    toggleFeatureEnabled: (context, featureName) => {
      context.commit("setFeatures", setFeaturesEnabledState(context.state.features, featureName));
      context.dispatch("setCookieData");
    },
    consentGiven: (context, value) => {
      if (value == "all") {
        context.commit("setFeatures", setFeaturesEnabledState(context.state.features));
      } else if (value == "required") {
        context.commit("setFeatures", context.state.defaultFeatures);
      }
      context.dispatch("setCookieData");
      context.commit("setShowCookieBanner", false);
    },
    setCookieData: context => {
      const cookieData = Object.entries(context.state.features).reduce((acc, [name, data]) => {
        acc[name] = data.enabled;
        return acc;
      }, {});
      document.cookie = `${context.state.cookieName}=${JSON.stringify(cookieData)}; max-age="10"`;
    },
    deleteCookieData: context => {
      document.cookie = `${context.state.cookieName}=;`;
    },
    upsertCookieData: context => {
      const cookieData = ("; " + document.cookie)
        .split(`; ${context.state.cookieName}=`)
        .pop()
        .split(";")[0];
      if (cookieData) {
        try {
          const parsedCookieData = JSON.parse(cookieData);
          const features = Object.entries(context.state.features).reduce((acc, [name, data]) => {
            acc[name] = data;
            acc[name].enabled =
              parsedCookieData[name] === true || parsedCookieData[name] === false
                ? parsedCookieData[name]
                : data.enabled;
            return acc;
          }, {});

          context.commit("setFeatures", features);
          context.dispatch("setCookieData");
        } catch (e) {
          context.commit("setShowCookieBanner", true);
          context.dispatch("deleteCookieData");
        }
      } else {
        context.commit("setShowCookieBanner", true);
      }
    },
    showCookieBanner: (context, value) => context.commit("setShowCookieBanner", value),
    setFeaturesFilter: (context, value) => context.commit("setFeaturesFilter", value),
  },
  mutations: {
    setFeatures: (state, data) => (state.features = data),
    setDefaultFeatures: (state, data) => (state.defaultFeatures = data),
    setShowCookieBanner: (state, value) => (state.showCookieBanner = value),
    setFeaturesFilter: (state, value) => (state.featuresFilter = value),
  },
};
